/**
 * @class away.base.HitTestCache
 */
var HitTestCache = (function () {
    function HitTestCache() {
        /**
         *
         */
        this.cells = new Array();
        /**
         *
         */
        this.lastCollisionIndex = -1;
    }
    return HitTestCache;
}());
export { HitTestCache };



// WEBPACK FOOTER //
// ../dist/lib/utils/HitTestCache.js